import { logIcon } from '@y42/feature/icons';
import { genericToolTip } from '@y42/gojs';
import { Binding, GraphObject, Margin, Panel, Picture, Size } from 'gojs';
import { OrchestrationDiagramParts } from '../../../../config/orchestration-part-names';

const $ = GraphObject.make;

const config = {
  colors: {
    fill: '#f3f4f6',
    fillOver: '#e4e6ea',
    fillPressed: '#d1d5dc',
  },
  logos: {
    showLogs: logIcon,
  },
};

export const ShowLogsButton = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []) =>
  $(
    Panel,
    Panel.Auto,
    {
      toolTip: Tooltip(),
      visible: false,
      ...props,
    },
    Button(),
    ...bindings,
  );

const Button = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []) =>
  $(
    'Button',
    {
      name: OrchestrationDiagramParts.ShowLogsButton,
      'ButtonBorder.strokeWidth': 0,
      'ButtonBorder.fill': config.colors.fill,
      _buttonFillOver: config.colors.fillOver,
      _buttonFillPressed: config.colors.fillPressed,
      margin: new Margin(0, 3),
      ...props,
    },
    ...bindings,

    icon(),
  );

const icon = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []) =>
  $(
    Picture,
    {
      desiredSize: new Size(16, 16),
      imageStretch: GraphObject.Uniform,
      margin: new Margin(4),
      source: config.logos.showLogs,
      ...props,
    },
    ...bindings,
  );

const Tooltip = () =>
  genericToolTip({ colors: { fill: 'white', stroke: '#666666' } }, [new Binding('text', '', () => 'Job Logs')]);
